import * as CONSTANTS from './../helpers/constants';
export function getInitialState() {
  return {
  busDetails:{},
  ratingReviewData:{},
  selectedSeatLayoutData:{},
  selectedSeatLayoutInfo:{},/* { bid: 
                                      {   isFetching:true,
                                          selectedTab:seatLayout,
                                          selectedSeats:{},
                                          selectedCategory:'',
                                          selectedBP:{},
                                          selectedDP:{},
                                          availableSeatPrice:[-1,100,200]
                                          selectedPrice:[-1] NOTE:- -1 represt all
                                          fareInfo:{priceAfterDiscount:150,priceWithoutDiscount:200,discount:50},
                                          data:{}
                                        
                                       }*/
 };
}

//TODO:- returning a new object each time with Object.assign instead of direct state manipulation
export default function SeatLayout(state = getInitialState(), action) {
  const {type, actionData} = action;

  switch (type) {
    case CONSTANTS.UPDATE_SELECTED_BUS_INFO:
      let selectedSeatLayoutInfo = Object.assign({},state.selectedSeatLayoutInfo);
    
      if(Object.keys(selectedSeatLayoutInfo).length && selectedSeatLayoutInfo[actionData.bid]){  
      for(let key in actionData.data){
        if(actionData.data.hasOwnProperty(key)){
          selectedSeatLayoutInfo[actionData.bid][key] = actionData.data[key];
        }
      }    
      }else{
        selectedSeatLayoutInfo[actionData.bid] = actionData.data;
  
      }
      return Object.assign({},state,{
        ...state,
        selectedSeatLayoutInfo:selectedSeatLayoutInfo
      });

     case CONSTANTS.UPDATE_SELECTED_BUS_DATA:
      let selectedSeatLayoutData = Object.assign({},state.selectedSeatLayoutData);
     
        if(!selectedSeatLayoutData[actionData.bid]){
          selectedSeatLayoutData[actionData.bid] = {};
  
        }
        if(actionData.data && Object.keys(actionData.data).length){
          selectedSeatLayoutData[actionData.bid].data = actionData.data ;
        }else{
          selectedSeatLayoutData[actionData.bid].data = selectedSeatLayoutData[actionData.bid].data || {} ;
          
        }
          
          selectedSeatLayoutData[actionData.bid].isLoading = actionData.isLoading;

          selectedSeatLayoutData[actionData.bid].error = actionData.error || false;
          return Object.assign({},state,{
            ...state,
            selectedSeatLayoutData:selectedSeatLayoutData
          });
         
    case CONSTANTS.UPDATE_RATING_REVIEW_DATA:
      let ratingReviewData = Object.assign({},state.ratingReviewData);
     
      if(!ratingReviewData[actionData.bid]){
        ratingReviewData [actionData.bid] ={data:[],error:'',isLoading:actionData.isLoading};
      }else{
      ratingReviewData[actionData.bid]['data'] = actionData.data;
      ratingReviewData[actionData.bid].error = actionData.error || '';
      ratingReviewData[actionData.bid].isLoading = actionData.isLoading ;
      }
      return Object.assign({},state,{
        ...state,
        ratingReviewData:ratingReviewData
      });
        
     case CONSTANTS.UPDATE_BUS_DETAILS:
       let busDetails = Object.assign({},state.busDetails);
       if(!busDetails.hasOwnProperty(actionData.bid)){
        busDetails[actionData.bid]={};
       }
        busDetails[actionData.bid]['isLoading'] = actionData.isLoading;
        busDetails[actionData.bid]['error'] = actionData.error || false;
        busDetails[actionData.bid]['data'] = actionData.data;
      
  
      return Object.assign({},state,{
        ...state,
        busDetails:busDetails
      });
    
    default:
      return state;
  }
}
